// extracted by mini-css-extract-plugin
module.exports = {"cont":"Types_cont__1yJv7","gridTypes":"Types_gridTypes__2Bc48","typesPoke":"Types_typesPoke__3AHAa","typescards":"Types_typescards__9Qetz"};